import * as Util from 'js/util/util.js'
import Vue from 'vue'
import richTxtTpl from './rich/index.js'

export const RICH_TXT_COPY = {
  data() {
    return {
      deliveryInfo: {}, // 外链信息
      isHistoryLink: false, // 历史列表
      lowBDialog: false, // 浏览器版本过低,复制弹窗
      copyText: '', // 浏览器版本过低,复制内容
    }
  },
  methods: {
    showTipsNoIcon(info, tipsType = 'warn') {
      window.$toast.originToast({
        toastInfo: { info, tipsType },
        value: true,
        show: true,
        isIcon: false,
      })
    },
    /**
         * 复制代码
         */
    setRichTpl(item) {
      this.link_url_copy = item.url || item.URL_VALUE
      this.linkUrl = this.link_url_copy
      if (item.has_password || item.PASSWORD) {
        this.param.password = item.has_password || item.PASSWORD
        this.link_url_copy += ` (${this.$t('提取码')}：${item.password || item.PASSWORD})`
      }
      if (item.delivery_status === 2) {
        this.showTipsNoIcon(this.$t('该链接已失效，需新建新链接提交审批后生效'))
        return false
      }
      if (item.expire) {
        this.param.expiration = item.expire === -1 ? '' : item.expire
      }
      if (item.path) {
        this.param.path = item.path
      }
      if (item.size) {
        this.param.size = item.size
        this.param.is_dir = false
      } else {
        this.param.is_dir = true
      }
      // ie浏览器用window.clipboardData复制
      if (window.clipboardData) {
        const ieMsg = this.$t('推荐IE以外的其他浏览器复制该内容,操作更方便')
        window.clipboardData.setData('text', `${this.link_url_copy} ${ieMsg}`)
        this.showTipsNoIcon(this.$t('链接地址已经复制到剪切板中'))
        return ''
      }
      // 非ie浏览器
      document.addEventListener('copy', this.listener, false)
      // 插入隐藏域并设置焦点和选中 确保execCommand(copy)能准确执行
      const hideInput = document.createElement('input')
      hideInput.id = 'rich-txt-copy-hide-input'
      hideInput.style.display = 'none'
      document.body.appendChild(hideInput)
      hideInput.value = this.link_url_copy
      hideInput.focus()
      hideInput.select()
      if (document.execCommand('copy')) {
        if (item.has_password || item.PASSWORD) {
          this.showTipsNoIcon(this.$t('链接和密码已复制成功'))
        } else {
          this.showTipsNoIcon(this.$t('链接已复制成功'))
        }
        this.copyText = this.link_url_copy
      } else {
        this.copyText = this.link_url_copy
        this.lowBDialog = true
      }
      document.body.removeChild(document.getElementById('rich-txt-copy-hide-input'))
      document.removeEventListener('copy', this.listener)
    },
    /**
         * 监听事件
         */
    listener(event) {
      let Template
      if (Util.getLanguage() === 'tw') {
        Template = Vue.extend(richTxtTpl.richTxtTw)
      } else if (Util.getLanguage() === 'en') {
        Template = Vue.extend(richTxtTpl.richTxtEn)
      } else {
        Template = Vue.extend(richTxtTpl.richTxtZh)
      }
      const html = new Template({
        el: document.createElement('div'),
        propsData: {
          deliveryInfo: this.isHistoryLink ? this.deliveryInfo : this.deliveryInfoLocal,
          data: this.metaData,
        },
      })
      // chrome etc.
      if (event.clipboardData) {
        event.clipboardData.setData('text/html', this.domToStr(html.$el))
        event.clipboardData.setData('text/plain', this.link_url_copy)
        event.preventDefault()
      }
    },
    domToStr(node) {
      let tmpNode = document.createElement('div')
      tmpNode.appendChild(node)
      const str = tmpNode.innerHTML
      tmpNode = node = null // 解除引用
      return str
    },
  },
  computed: {
    deliveryInfoLocal() {
      // 返回本地外链信息
      return {
        url: this.linkUrl,
        ...(this.param),
      }
    },
  },
}
